<script>
    import { CollapseTransition } from "@ivanv/vue-collapse-transition";

    export default {
        name: "CollapsibleSection",

        components: {
            CollapseTransition,
        },

        props: {
            number: {
                type: String,
                required: false,
            },
            heading: {
                type: String,
                required: true,
            },
            grid: {
                type: Boolean,
                default: false,
            },
            isExpanded: {
                type: Boolean,
                default: true,
            },
            isSingle: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                show: this.isExpanded,
            };
        },
        watch: {
            isExpanded(newVal) {
                this.show = newVal;
            },
        },
    };
</script>

<template>
    <div class="collapsible-section">
        <div class="header">
            <h3>
                <div v-if="!isSingle" class="circle">
                    <div class="number">{{ number }}</div>
                </div>
                <div class="toggle" @click.prevent="show = !show">
                    {{ heading }}
                    <img src="@/assets/dropdown-arrow-blue.svg" class="chevron" :class="{ rotate: show }" />
                </div>
            </h3>
        </div>
        <div :class="{ outer: !isSingle }">
            <collapse-transition>
                <div class="content" :class="{ inner: !isSingle, grid: grid }" v-show="show">
                    <slot></slot>
                </div>
            </collapse-transition>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .collapsible-section {
        margin-bottom: 0.5rem;
        max-width: 100%;

        .header {
            div {
                display: inline-block;
            }

            .circle {
                height: 26px;
                width: 26px;
                background-color: #277692;
                border-radius: 50%;
                position: relative;
                left: -13px;

                .number {
                    display: grid;
                    place-items: center;
                    height: 100%;
                    width: 100%;
                    color: #ffffff;
                    font-family: Roboto;
                    font-size: 1rem;
                    letter-spacing: 0;
                    text-align: center;
                }
            }

            .toggle {
                cursor: pointer;
            }
        }

        .outer {
            border-left: 1px solid #8ebaca;

            .inner {
                padding-left: 26px;
                padding-bottom: 15px;

                &.grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
                    grid-row-gap: 36px;
                    grid-column-gap: 26px;
                }
            }
        }

        img {
            &.chevron {
                margin-left: 15px;
            }

            &.rotate {
                transform: rotate(180deg);
            }
        }
    }
</style>
